import type { RefObject } from 'react';
import type { HeadingRef } from '../../atoms/heading/Heading.data';
import { findTransitionController } from '../../../util/core-transition-component';

interface IntroColumnTextRefs {
  elementRef: RefObject<HTMLElement | null>;
  titleRef: RefObject<HeadingRef | null>;
  // descriptionRef?: RefObject<TextRef>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { titleRef }: IntroColumnTextRefs,
): void {
  const title = findTransitionController(titleRef);
  // const description = findTransitionController(descriptionRef);

  if (title) {
    timeline.add(title.getTimeline('in') as gsap.core.Timeline, 0);
  }
  // if (description) {
  //   timeline.add(description.getTimeline('in') as gsap.core.Timeline, 0.2);
  // }
}
